import useCustomerSubscriptionMutations from "features/subscriptions/datahooks/useCustomerSubscriptionMutations";
import useWorkspaceSubscriptionMutations from "features/subscriptions/datahooks/useWorkspaceSubscriptionMutations";
import { trackSubscriptionEvent } from "features/subscriptions/utils";

import type { SubscriptionType } from "common/types";

export default function useCreateSubscription(
  subscriptionType: SubscriptionType,
) {
  const {
    createCustomerSubscription,
    isCreatingCustomerSubscription,
    createCustomerSubscriptionError,
  } = useCustomerSubscriptionMutations();
  const {
    createWorkspaceSubscription,
    isCreatingWorkspaceSubscription,
    createWorkspaceSubscriptionError,
  } = useWorkspaceSubscriptionMutations();

  async function createSubscription({
    quantity,
    planId,
    paymentSourceId,
    planValue,
  }: {
    quantity: number;
    planId: string;
    paymentSourceId: string;
    planValue: number;
  }) {
    let subscriptionId: string;
    if (subscriptionType === "agency") {
      const { subscription } = await createCustomerSubscription({
        count: quantity,
        paymentSourceId,
        planPricingId: planId,
      });
      subscriptionId = subscription.id;
    } else {
      const { workspace } = await createWorkspaceSubscription({
        count: quantity,
        planId,
        paymentSourceId,
        type: subscriptionType,
      });
      subscriptionId = (
        subscriptionType === "rental"
          ? workspace.rental_subscription
          : workspace.subscription
      ).id;
    }
    trackSubscriptionEvent("subscribe", subscriptionId, planValue, quantity);
  }

  return {
    createSubscription,
    isCreatingSubscription:
      isCreatingCustomerSubscription || isCreatingWorkspaceSubscription,
    createSubscriptionError:
      createCustomerSubscriptionError || createWorkspaceSubscriptionError,
  };
}
